module.exports = __webpack_public_path__ + "static/media/travclan-logo-new.cacb55d3.png";